module.exports = __webpack_public_path__ + "img/71.c65d77ba.jpg";